export const AUTH_QUERY_KEY_ROOT = 'auth';
